// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAcquireSection1X_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 17.5001C15.0376 17.5001 17.5 15.0377 17.5 12.0001C17.5 8.96254 15.0376 6.5001 12 6.5001C8.96243 6.5001 6.5 8.96254 6.5 12.0001C6.5 15.0377 8.96243 17.5001 12 17.5001ZM12 19.0001C15.866 19.0001 19 15.8661 19 12.0001C19 8.13411 15.866 5.0001 12 5.0001C8.13401 5.0001 5 8.13411 5 12.0001C5 15.8661 8.13401 19.0001 12 19.0001Z" class="svg-bg"/>
  <path d="M2.98438 19.9549L19.9549 2.98438L21.0156 4.04504L4.04504 21.0156L2.98438 19.9549Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAcquireSection1X is a generated icon component.
 */
let IconMedAcquireSection1X = IconMedAcquireSection1X_1 = class IconMedAcquireSection1X extends IconBaseElement {
    render() {
        return html `${IconMedAcquireSection1X_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAcquireSection1X.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAcquireSection1X = IconMedAcquireSection1X_1 = __decorate([
    customElement('zui-icon-med-acquire-section-1-x')
], IconMedAcquireSection1X);
export { IconMedAcquireSection1X };
